export default __webpack_public_path__ + "static/media/download.ce737b0e.png";